









































































































































































import { Vue, Component, Ref } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
//  types
import { ExtendedVessel } from "@/types/vessel";
import { DataQualityDataAlignmentModel, DataQualityFeatureAlignment, DataFeatureValues } from "@/types/dataQuality/dataAlignment";
//  components
import StatusCard from "@/components/dataQuality/DataAlignment/StatusCard.vue";
import DataAlignmentChart from "@/components/dataQuality/DataAlignment/Charts/DataAligmentChart.vue";
//  modules
import { getModule } from "vuex-module-decorators";
import SnackbarModule from "@/store/clients/Snackbar.module";
import DataQualityModule from "@/store/clients/DataQuality.module";
import VesselsModule from "@/store/clients/Vessels.module";
import CdsModule from "@/store/clients/Cds.module";

const DataQuality = getModule(DataQualityModule, store);
const Vessels = getModule(VesselsModule, store);
const Snackbar = getModule(SnackbarModule, store);
const Cds = getModule(CdsModule, store);

@Component({
  components: {
    StatusCard,
    DataAlignmentChart,
  },
})
export default class DataAlignment extends Vue {
  @Ref("DataAlignmentCharts") DataAlignmentCharts!: any[];

  selectedVessel: ExtendedVessel | null = null;
  // TODO current dayte and year back
  searchQuery = "";
  dates: string[] = [moment().subtract(1, "years").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
  date = moment().format("YYYY-MM-DD");
  maxDate = moment().format("YYYY-MM-DD");
  menu = false;
  vesselWithFeatures: ExtendedVessel[] = [];
  loadingVessels = false;
  loadingDataAlignment = false;

  //  @Watchers
  async onSelectedVesselChange(): Promise<void> {
    this.loadingDataAlignment = true;
    this.queryRequest.vesselId = this.selectedVessel?.id || 0;
    await this.fetchDataAlignment();
  }

  //  @Getters
  get filteredVessels(): ExtendedVessel[] {
    return Vessels.extendedVessels.filter(vessel => this.hasDataQualityEnabled(vessel));
  }

  get extendedVessels(): ExtendedVessel[] {
    return Vessels.extendedVessels.filter(vessel => this.hasDataQualityEnabled(vessel));
  }

  get dataAlignmentData(): DataQualityDataAlignmentModel {
    return DataQuality.dataAlignmentData;
  }

  get dataAlignmentDataLoadingState(): boolean {
    return DataQuality.dataAlignmentLoadingState;
  }

  get dateRangeText(): string {
    return `${moment(this.dates[0]).format("ll")} - ${moment(this.dates[1]).format("ll")}`;
  }

  get dateRange(): string {
    return `${moment(this.dates[0]).format("DD MMM")} - ${moment(this.dates[1]).format("DD MMM")}`;
  }

  get queryRequest(): { vesselId: number; fromDate: string; toDate: string } {
    return { vesselId: this.selectedVessel?.id || 0, fromDate: this.dates[0], toDate: this.dates[1] };
  }

  //  @Methods
  async fetchDataAlignment(): Promise<void> {
    this.loadingDataAlignment = true;
    try {
      await DataQuality.fetchDataAlignment(this.queryRequest);
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to fetch data alignment data" });
    } finally {
      this.loadingDataAlignment = false;
    }
  }

  async setDateRange(date: string): Promise<void> {
    (this.$refs.datepickerMenu as any).save(date);
    this.queryRequest.fromDate = this.dates[0];
    this.queryRequest.toDate = this.dates[1];
    await this.fetchDataAlignment();
  }

  async filterVesselsByFeature(featureName: string): Promise<void> {
    const candidates = Vessels.extendedVessels;
    const requiredPairs: [string, string][] = [
      ["Speed Through Water", "Speed Through Water [Noon]"],
      ["Shaft Power", "Shaft Power [Noon]"],
      ["ME Total Eq FO Mass Flow", "ME Total Eq FO Mass Flow [Noon]"],
    ];

    const featureChecks = candidates.map(async vessel => {
      try {
        const features = await Cds.fetchVesselFeatures(vessel.id);
        const featureNames = features.map(feature => feature.name);

        const hasMatchingPair = requiredPairs.some(([a, b]) => featureNames.includes(a) && featureNames.includes(b));

        return hasMatchingPair ? vessel : null;
      } catch (error) {
        console.warn(`Failed to fetch features for vessel ${vessel.name}`, error);
        return null;
      }
    });

    const results = await Promise.all(featureChecks);

    this.vesselWithFeatures = results.filter((v): v is ExtendedVessel => v !== null && this.hasDataQualityEnabled(v));
  }

  hasDataQualityEnabled(vessel: ExtendedVessel): boolean {
    return vessel.features.some(feature => feature.name === "DataQuality");
  }

  onDataAlignmentChartZoom(selection: { from: string; to: string; resetZoom: boolean }): void {
    (this.DataAlignmentCharts as any[]).forEach(chart => chart.zoom(selection));
  }

  //  @Hooks
  async created(): Promise<void> {
    this.loadingVessels = true;
    try {
      await Vessels.refreshExtendedVessels();
      await this.filterVesselsByFeature("[Noon]");
      const vesselNameRedirected = this.$route.query.find;
      const foundVesselObj = this.extendedVessels.find(vessel => vessel.name === vesselNameRedirected);
      this.selectedVessel = foundVesselObj ? foundVesselObj : this.extendedVessels[0];
      this.queryRequest.vesselId = this.selectedVessel?.id || 0;
      this.loadingVessels = false;
      await this.fetchDataAlignment();
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to fetch vessels" });
    } finally {
      this.loadingVessels = false;
    }
  }
}
